import React from 'react';
import { Form, Progress } from 'antd';

class DepositSuccess extends React.Component {
    render() {
        return (
            <div>
                <Progress type="circle" percent={100} width={50} />
                <br />
                <br />
                <h3>Congratulations, your deposit was successful!</h3>
                <p>You will receive a follow-up email confirming receipt of your deposit and next steps within 1-2 business days. After one hour from deposit, you should be able to log into your MyVoyage portal, by visiting <a href="https://portal.semesteratsea.org">https://portal.semesteratsea.org</a> or clicking the log in link below and set your password with the email address you used to make your deposit. You will not use the same deposit code you used to make your deposit. Please contact us if you are still unable to log in after one full business day.</p>
                <br />
            </div>
        );
    }
}

export default Form.create()(DepositSuccess);



// WEBPACK FOOTER //
// ./src/containers/Login/DepositSuccess.jsx